export default __webpack_public_path__ + "static/media/aboutImg.4a8ababc.jpg";